<template>
	<div class="snowContainer">
		<div
			v-for="flake in snowflakes"
			:key="flake.id"
			class="snow"
			:style="{
				'--left': `${flake.left}%`,
				'--duration': `${flake.duration}s`,
				'--delay': `${flake.delay}s`,
				'--size': `${flake.size}px`,
				'width': `${flake.size}px`,
				'height': `${flake.size}px`
			}"
		>
			<v-img
				:src="require('@/assets/quiz/snow-flake.png')"
				class="snowflake-image"/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SnowEffect',
	data() {
		return {
			snowflakes: []
		};
	},
	created() {
		// Generate 30 snowflakes with random properties
		const count = 30;
		const leftPositions = [10, 20, 30, 40, 50, 60, 70, 80, 90, 15, 25, 35, 45, 55, 65, 75, 85, 95, 5, 12, 22, 32, 42, 52, 62, 72, 82, 92, 18, 28];
		const durations = [12, 14, 16, 13, 15, 14, 12, 14, 13, 15, 16, 12, 14, 15, 13, 15, 16, 12, 14, 15, 13, 15, 16, 12, 14, 15, 13, 15, 16, 12];
		const delays = [0, 2, 4, 6, 1, 3, 5, 7, 0.5, 2.5, 4.5, 6.5, 1.5, 3.5, 5.5, 7.5, 0.2, 2.2, 4.2, 6.2, 0.8, 2.8, 4.8, 6.8, 0.3, 2.3, 4.3, 6.3, 1.2, 3.2];
		const sizes = [40, 50, 45, 48, 40, 50, 45, 48, 40, 50, 45, 48, 40, 50, 45, 48, 40, 50, 45, 48, 40, 50, 45, 48, 40, 50, 45, 48, 40, 50];

		for (let i = 0; i < count; i++) {
			this.snowflakes.push({
				id: i,
				left: leftPositions[i],
				duration: durations[i],
				delay: delays[i],
				size: sizes[i]
			});
		}
	}
};
</script>

<style scoped>
.snowContainer {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	pointer-events: none;
	z-index: 0;
	background: linear-gradient(
		to bottom,
		#D3D3D3 0%,
		#F0F0F0 100%
	);
}

.snow {
	position: absolute;
	top: -100px;
	left: var(--left);
	animation: fall linear infinite;
	animation-duration: var(--duration);
	animation-delay: var(--delay);
	opacity: 0.8;
	display: flex;
	align-items: center;
	justify-content: center;
}

.snowflake-image {
	width: 100%;
	height: 100%;
}

@keyframes fall {
	from {
		transform: translateY(-100px) translateX(0);
	}
	25% {
		transform: translateY(25vh) translateX(30px);
	}
	50% {
		transform: translateY(50vh) translateX(0);
	}
	75% {
		transform: translateY(75vh) translateX(-30px);
	}
	to {
		transform: translateY(100vh) translateX(0);
	}
}
</style>